import { Rewards } from '@arrived/models';

import { rewardsApi } from '../api';

export const getRewardsRedemption = async (rewardUuid: string) => {
  const response = await rewardsApi.get<Rewards.RewardRedemption>(
    `/reward-redemptions/${rewardUuid}?includeVouchers=true&includePromotion=true`
  );
  return response.data;
};
